<template>
  <div>
    <ts-dialog
      :title="`Create a ${group == 'delivery' ? 'Delivery ' : ''} file request`"
      :visible.sync="visible"
      width="500px"
      center
      :show-close="false"
    >
      <div>
        <ts-form-item label="Title of the file request" :validation="$v.form.name">
          <ts-input placeholder="" v-model.lazy="$v.form.name.$model"></ts-input>
        </ts-form-item>
        <ts-form-item label="Description of the file request" :validation="$v.form.description">
          <ts-input type="textarea" :rows="4" placeholder="" v-model.lazy="$v.form.description.$model"></ts-input>
        </ts-form-item>
        <ts-form-item
          v-if="group == 'delivery'"
          label="Select a plateform for the received assets (optional) "
          :validation="$v.form.platforms"
          class="dropdown"
        >
          <MultiSelectionDropdown
            placeholder="Select platforms"
            :width="378"
            size="large"
            :options="platforms"
            v-model.lazy="$v.form.platforms.$model"
          >
          </MultiSelectionDropdown>
        </ts-form-item>
      </div>
      <span slot="footer">
        <div class="footer">
          <ts-button @click="handleSaveClick">Create</ts-button>
        </div>
      </span>
    </ts-dialog>
    <ts-button size="small" @click="handleOpenDialogButtonClick"> Create file request </ts-button>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';
import MultiSelectionDropdown from '@/components/inputs/MultiSelectionDropdown.vue';
export default {
  components: { MultiSelectionDropdown },
  props: {
    group: {
      type: String,
      default: 'assets'
    }
  },
  data() {
    return {
      visible: false,
      form: {
        name: '',
        description: '',
        flexible: true,
        platforms: [],
        deadline: null
      }
    };
  },
  validations: {
    form: {
      name: {
        required
      },
      platforms: {},
      description: {
        required
      }
    }
  },
  computed: {
    ...mapState('workflow', {
      platforms: state => state.myProjects.options.platforms
    })
  },
  methods: {
    handleOpenDialogButtonClick() {
      this.visible = true;
    },
    handleSaveClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('input', { ...this.form, group: this.group });
        this.visible = false;
        this.resetForm();
      }
    },
    resetForm() {
      this.form = {
        name: '',
        description: '',
        flexible: true,
        deadline: null,
        platforms: []
      };
      this.$v.$reset();
    }
  }
};
</script>

<style>
</style>